<!-- Select Manager component -->
<script>
import axios from "axios";
import Loader from "../shared/components/loader/loader.vue";
import Tabs from "../shared/components/tabs/tabs.vue";
import Errors from "../shared/components/errors-page/errors.vue";
import StoreHeader from "../shared/components/store-header/store-header.vue";
import StoreFooterMobile from "../shared/components/store-footer-mobile/store-footer-mobile.vue";

export default {
  data() {
    return {
      networkError: false,
      error: false,
      error401: false,
      error500: false,
      errorOther: false,
      isLoading: true,
      search: "",
      managerNames: [],
      selectedManagers: [],
      selectedManagersStored: [],
      selected: [],
      allSelected: false,
      managerIds: [],
      isNextButtonActive: false
    };
  },
  components: {
    Loader,
    Tabs,
    Errors,
    StoreHeader,
    StoreFooterMobile,
  },
  mounted () {
    this.isNextButtonActive = false
    if (this.$store.state.selectedManagers.length > 0) {
      this.selectedManagers = this.$store.state.selectedManagers
    }
  },
  methods: {
    goToHomePage () {
      window.parent.location.href = this.$store.getters.domain;
    },
    selectAll() {
      this.selectedManagers = [];
      if (!this.allSelected) {
        this.managerNames.map((manager) => {
          this.selectedManagers.push(manager.pin);
        });
      } else if (this.allSelected) {
        this.selectedManagers = [];
      }
    },
    select: function () {
      this.allSelected = false;
    },
    nextPage() {
      if (this.selectedManagers.length > 0) {
        if (this.$store.state.assignedManagers.managers) {
          let assignedManagers = this.$store.state.assignedManagers
          let managers = []
          this.selectedManagers.forEach(pin => {
            let filterData = assignedManagers.managers.filter(val => {
              return pin === val.pin
            })
            if (filterData.length > 0) {
              managers.push(filterData[0])
            } else {
              let managerName = this.$store.state.managerNames.find(val => {
                return pin === val.pin
              })
              if (managerName !== undefined) {
                managers.push({
                  name: managerName.fName,
                  pin: pin,
                  points: 0,
                  price: 0
                })
              }
            }
          })
          assignedManagers.managers = managers
          this.$store.commit(
                "updateAssingedManagers",
                assignedManagers
              );
        }
        this.isNextButtonActive = true
        this.$store.commit("updateSelectedManagers", this.selectedManagers);
        const code = this.$route.params.code;
        this.$router.push(`/assign/assign-points/${code}`);
      }
    },
    backPage() {
      this.$store.commit("updateSelectedManagers", this.selectedManagers);
      this.$router.push("/");
    },
    translateRole(role) {
      switch (role) {
        case "Supervisor Operator mpl level":
          return this.$tc("message.roles", 0)
        case "General Manager":
          return this.$tc("message.roles", 1)
        case "Salaried Manager":
          return this.$tc("message.roles", 2)
        case "Shift Leader":
          return this.$t("message.shiftLeaderRole")
        default:
          return role
      }
    }
  },
  created() {
    if (navigator.onLine) {
      this.networkError = false;
      this.error = false;
    } else {
      this.error = true;
      this.networkError = true;
    }
    const code = this.$route.params.code;
    let url = `${process.env.VUE_APP_API_URL}/Members/advancedMemberSearch?orgnode_code=${code}`
    if (process.env.VUE_APP_SHOW_CSRF.toLowerCase() === 'true') {
      let token = this.$store.state.userData.session._csrf
      url += `&token=${token}`
    }
    axios
      .get(url,
        { withCredentials: true }
      )
      .then((res) => {
        this.managerNames = res.data;
        this.$store.commit("updateManagersNames", res.data);
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.data.error.status === 401) {
          this.error = true;
          this.error401 = true;
        } else if (error.response.data.error.status === 500) {
          this.error = true;
          this.error500 = true;
        } else {
          this.error = true;
          this.errorOther = true;
        }
      });
  },
  computed: {
    disabled() {
      return this.selectedManagers.length < 1; // or === 0
    },
    noManagersData() {
      return this.managerNames.length > 0;
    },
    assignTableHeading () {
      return process.env.VUE_APP_SELECT_MANAGER_MSG || this.$t('message.assigntableHeading')
    }
  },
  name: "assign-manager",
};
</script>

<!-- Template -->
<template >
  <fragment>

    <div v-if="!error" class="container-fluid">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-md-12 offset-md-0 mobilepadall">
          <div>
            <div class="hide-on-mob">
              <!-- Store Header --Start -->
              <store-header
                @back="backPage"
                info="no"
                nextbtn="yes"
                @next="nextPage"
                :disabled="disabled"
              ></store-header>
              <!-- Store Header --End -->
            </div>

            <div class="select-container-manager">
              <!-- Tabs Start-->
              <tabs
                tabTitle1="active"
                tabNumber1="active-number"
                border1="active-border"
                border2="inactive-border"
                border3="inactive-border"
              ></tabs>
              <!-- Tabs end -->
              <div class="main-container">
                <div class="container-fluid">
                  <b-row
                    class="justify-content-md-center container-section pad-lf-rt-24"
                  >
                    <b-col md="6" sm="12" class="pl-0 mobile-margin selfalign">
                      <div class="select-manager-title">
                        <h3>{{ assignTableHeading }}</h3>
                      </div>
                    </b-col>
                    <b-col
                      md="6"
                      sm="12"
                      class="pr-0 pl-0 mobile-margin"
                    ></b-col>
                  </b-row>
                </div>
                <!-- Web Table Start-->
                <div class="hide-on-mob">
                  <div class="container-heading-row">
                    <div class="checkbox-section border-right">
                      <input
                        class="checkbox1"
                        id="employee-name"
                        name="managerNames"
                        type="checkbox"
                        value="one"
                        v-model="allSelected"
                        @click="selectAll"
                        hidden
                      />
                      <label class="checkmark" for="employee-name"></label>
                    </div>
                    <div class="col title-section border-right">
                      <span>{{ $tc("message.assignTableTitle", 0) }}</span>
                    </div>
                    <div class="col id-section border-right">
                      <span>{{ $tc("message.assignTableTitle", 1) }}</span>
                    </div>
                    <div class="col role-section">
                      <span>{{ $tc("message.assignTableTitle", 2) }}</span>
                    </div>
                  </div>
                  <div v-if="isLoading === false">
                    <div class="manager-container-body" v-if="noManagersData">
                      <div
                        class="container-body-row"
                        v-for="manager in managerNames"
                        :key="manager.pin"
                      >
                        <div class="checkbox-section">
                          <input
                            class="checkbox1"
                            :id="manager.pin"
                            name="selectedManagers"
                            type="checkbox"
                            :value="manager.pin"
                            v-model="selectedManagers"
                            @click="select"
                            hidden
                          />
                          <label class="checkmark" :for="manager.pin"></label>
                        </div>
                        <div class="col title-section text-capitalize">
                          <span>{{ manager.fName }} {{manager.lName}}</span>
                        </div>
                        <div class="col id-section text-uppercase">
                          <span>{{ manager.employeeId }}</span>
                        </div>
                        <div class="col role-section">
                          <span>{{ translateRole(manager.role) }}</span>
                        </div>
                      </div>
                      </div>
                      <!--No Data Message Start-->
                      <div class="manager-container-body" v-else>
                        <div class="no-data-wrapper">
                          <img
                            class="alertimg"
                            src="../../assets/alert.svg"
                            alt
                          />
                          <p class="no-data-title mb-0 mt-3">{{ $t("message.noManagerMessage") }}</p>
                          <b-button
                            @click="goToHomePage"
                            class="another-page-button mt-4 next-button-color btn-ripple mx-auto"
                            variant="light"
                            >{{$t('message.goToHomePage')}}</b-button
                          >
                        </div>
                      </div>
                      <!--No Data Message Ends-->
                  </div>
                  <loader v-if="isLoading === true"></loader>
                </div>
                <!-- Web Table end-->
                <!-- Mobile Table  Start-->
                <div class="mobileVisible">
                  <div class="container-heading-row-mobile">
                    <div class="checkbox-section-mobile border-right">
                      <input
                        class="checkbox1"
                        id="employee-name"
                        name="managerNames"
                        type="checkbox"
                        value="one"
                        v-model="allSelected"
                        @click="selectAll"
                        hidden
                      />
                      <label class="checkmark" for="employee-name"></label>
                    </div>
                    <div class="title-section">
                      <span>{{ $tc("message.assignTableTitle", 0) }}</span>
                    </div>
                  </div>
                  <div class="manager-container-body" v-if="noManagersData">
                    <div
                      class="container-body-row-mobile"
                      v-for="manager in managerNames"
                      :key="manager.pin"
                    >
                      <div class="checkbox-section-mobile border-right">
                        <input
                          class="checkbox1"
                          :id="manager.pin"
                          name="selectedManagers"
                          type="checkbox"
                          :value="manager.pin"
                          v-model="selectedManagers"
                          @click="select"
                          hidden
                        />
                        <label class="checkmark" :for="manager.pin"></label>
                      </div>
                      <div class="title-section-mobile text-capitalize">
                        <span>{{ manager.fName }} {{ manager.lName }}</span>
                        <div class="id-section-mobile text-uppercase">
                          <span>
                            <strong>ID:</strong>
                            {{ manager.pin }}
                          </span>
                        </div>
                      </div>

                      <div class="role-section-mobile">
                        <span>
                          <strong
                            >{{ $tc("message.assignTableTitle", 2) }}:</strong
                          >
                          {{ manager.orgnodeName }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!--No Data Message Start-->
                  <div class="manager-container-body" v-else>
                    <div class="no-data-wrapper">
                    <img
                      class="alertimg"
                      src="../../assets/alert.svg"
                      alt
                    />
                    <p class="no-data-title mb-0 mt-3">{{ $t("message.noManagerMessage") }}</p>
                    <b-button
                      @click="goToHomePage"
                      class="btn another-page-button next-button-color btn-ripple mt-4 mx-auto"
                      variant="light"
                      >{{$t('message.goToHomePage')}}</b-button
                    >
                  </div>
                </div>
                <!--No Data Message Ends-->
                  <store-footer-mobile
                    @back="backPage"
                    info="no"
                    nextbtn="yes"
                    @next="nextPage"
                    :disabled="disabled"
                  ></store-footer-mobile>
                </div>
                <!-- Mobile Table end  -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <errors
      v-else
       :errorNetworkrErrorprops="this.networkError"
      :error401props="this.error401"
      :error500props="this.error500"
      :errorOtherprops="this.errorOther"
    ></errors>
  </fragment>
</template>

<!-- Style -->
<style lang="scss">
.another-page-button {
  min-width: 270px;
  padding: 12px;
  display: unset;
  border-radius: 4px;
  border: none;
}
.select-container-manager .checkbox-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.select-container-manager .checkmark {
  position: relative;
  display: block;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border: 1.5px solid #c1c8cf;
  box-sizing: border-box;
  border-radius: 5px;
  transition: background-color 0.4s;
  margin-bottom: 0px;
}

.select-container-manager .checkbox1:checked ~ .checkmark {
  background-color: var(--primary-bg);
  border: 1.5px solid var(--primary-bg);
}

.select-container-manager .checkmark::after {
  content: "";
  position: absolute;
  width: 7.22px;
  height: 12.73px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%) rotateZ(40deg) scale(2);
  opacity: 0;
  transition: all 0.2s;
}

.select-container-manager .checkbox1:checked ~ .checkmark::after {
  opacity: 1;
  transform: translate(-50%, -50%) rotateZ(40deg) scale(1);
}
.manager-container-body {
  max-height: 46.6vh;
  height: 46.6vh;
}
@media (max-width: 768px) {
  .select-container-manager .checkmark {
    width: 20px;
    height: 20px;
  }
  .container-heading-row .title-section {
    font-size: 13px !important;
  }
}

.container-tabs {
  background-color: white;
  padding: 0;
}

.mobileGrid {
  padding: 1.4vh 0;
  border: 1px solid #e5e5e5;
}
.mobileGrid:first-child {
  border-top-left-radius: 5px;
}
.mobileGrid:last-child {
  border-top-right-radius: 5px;
}
.container-section {
  position: relative;
  min-height: 12.35vh;
  max-height: 12.35vh;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
}
.manager-container-body {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-top: none;
  box-sizing: border-box;
  border-radius: 0 0 5px 5px;
  margin: auto;
  // height: 56vh;
  // max-height: 56vh;
  overflow: auto;
}
.container-heading-row {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #e5e5e5;
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  background-color: white;
}

.container-body-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 0 0;
  border-bottom: 1px solid #e5e5e5;
  background-color: white;
}

.border-right {
  border-right: 1px solid #e5e5e5;
}

.checkbox-section {
  padding: 1.9vh 24px;
  min-width: 6%;
}

.container-body-row {
  background-color: #ffffff;
}

.title-section {
  padding: 1.9vh 24px;
}

.id-section {
  padding: 1.9vh 24px;
}

.role-section {
  padding: 1.9vh 24px;
  text-align: left;
}

.container-heading-row .title-section,
.container-heading-row .id-section,
.container-heading-row .role-section span {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #7d8c9b;
}

.container-body-row .title-section span,
.container-body-row .id-section span,
.container-body-row .role-section span {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  align-items: center;
  color: #333;
}

.select-manager-title h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #45505b;
  margin-bottom: 0px;
}

.arrow {
  width: 23px;
  padding-bottom: 3px;
}

.back-button {
  float: left;
  width: 150px;
  height: 48px;
  font-style: normal;
  font-size: 15px;
  line-height: 30px;
  color: #333;
  background-color: white;
  border: none;
  text-align: left;
  padding-left: 0px;
  font-weight: normal;
}

.back-button:hover {
  background-color: white;
}
.next-button {
  width: auto;
  border: none;
  font-weight: 400;
  padding: 15px;
  border-radius: 6px;
  color: #292929 !important;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  text-decoration: none;
  letter-spacing: 1px;
  z-index: 1;
  transition: all 0.10s ease-in-out;
  cursor: pointer;
  box-sizing: border-box;
  text-align: center;
}
.next-button-color {
  background: var(--secondary-bg) !important;
  border-color: var(--secondary-bg) !important;
  color: var(--secondary-bg-text) !important;
}
.next-button-color:hover, .next-button-color:active {
  background: var(--button-hover-bg) !important;
  border-color: var(--button-hover-bg) !important;
  color: var(--button-hover-bg-text) !important;
}

.next-button:disabled {
  background: #bdbdbd !important;
}


.btn-ripplea {
  display: inline-block;
  position: relative;
  overflow: hidden;
  transition: all ease-in-out 0.5s;
}

.btn-ripplea::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 25%;
  height: 100%;
  width: 50%;
  background-color: #000;
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
  transition: all ease-in-out 1s;
  transform: scale(5, 5);
}

.btn-ripplea:active::after {
  padding: 0;
  margin: 0;
  opacity: 0.2;
  transition: 0s;
  transform: scale(0, 0);
}

.store-title {
  font-style: normal;
  font-weight: bold;
  font-size: 31px;
  line-height: 38px;
  margin: 0 auto;
  letter-spacing: 0.1925px;
  color: #333;
}
.alertimg{
    width: 30.67px;
    height: 30.67px;
    border-radius: 50%;
    top: 2.08%;
    bottom: 2.08%;
}
.no-data-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 46.0vh;
}
.no-data-title {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #45505B;
  letter-spacing: 0.1px;
  text-align: center;
}
.go-to-homepage-button {
  min-width: 297px;
  padding: 12px;
  border-radius: 5px;
  border: 1px solid;
  background: #F8F8F8;
  text-align: center;
  font-weight: 500;
}
@media (max-width: 1366px) {
  .store-title {
    font-size: 27px;
  }
}
@media (min-width: 600px) and (max-width: 736px) {
  .store-title {
    font-size: 18px;
  }
  .next-button {
    float: right;
    width: auto;
  }
  .next-button {
    padding: 13px 29px;
  }
}
@media (min-width: 701px) and (max-width: 768px) {
  .store-title {
    font-size: 22px;
  }
  .next-button {
    float: right;
    width: auto;
    max-width: 80%;
  }
}

@media (max-width: 600px) {
  .next-button {
    width: 100%;
    margin-right: 8px !important;
  }
  .main-container {
    max-height: unset;
    min-height: auto;
    height: auto;
  }
  .manager-container-body {
    max-height: 60vh;
    height: 60vh;
    border-bottom: none;
  }
}
.tab-number {
  background-color: #c1c8cf;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  color: #fff;
  margin: 5px auto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  display: inline-block;
  margin-right: 8px;
}
@media (max-width: 600px) {
  .tab-number {
    margin-right: auto;
  }
}
.tab-title {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: var(--primary-bg);
  width: 100%;
}

.active {
  color: var(--primary-bg);
}

.active-number {
  background-color: var(--primary-bg);
}

.order-title {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: #687888;
}

.select-employee {
  float: right;
  width: 220px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #c1c8cf;
  box-sizing: border-box;
  border-radius: 5px;
  background-image: url("../../assets/search.svg");
  background-position: 22px 10px;
  background-repeat: no-repeat;
  padding: 10px 20px 12px 55px;
}
.select-employee::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #c1c8cf;
}
.select-employee:focus {
  background: white;
  border: 1px solid #c1c8cf;
  background-image: url("../../assets/search.svg");
  background-position: 22px 10px;
  background-repeat: no-repeat;
  padding: 10px 20px 12px 55px;
  box-sizing: border-box;
  box-shadow: none;
}

.checkbox {
  width: 24px;
  height: 24px;
}

.employee-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.1925px;
  color: #333;
}

.employee-id {
  display: block;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.1925px;
  color: #333;
}

.employee-pts {
  position: relative;
  top: 20px;
  display: block;
  float: right;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  letter-spacing: 0.1925px;
  color: #333;
}

.employee-point {
  position: relative;
  top: 16px;
  display: block;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.1925px;
  color: #333;
}
.employee-detail {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.checkbox-container {
  width: 5%;
  display: inline-block;
}
.name-container {
  width: 75%;
  display: inline-block;
  height: 50px;
}

.id-container {
  width: 20%;
  display: inline-block;
  height: 50px;
}

@media (min-width: 768px) and(max-width:992px) {
  .checkbox-section {
    min-width: 10%;
  }
  .next-button {
    padding: 15px 48px;
  }
  .alert-inf {
    margin-top: 16px;
    margin-right: 10px;
  }
}
@media (min-width: 993px) and(max-width:1024px) {
  .checkbox-section {
    min-width: 6%;
  }
}

@media (max-width: 360px) {
  .next-button {
    padding: 0 8%;
  }
}

@media (max-width: 300px) {
  .next-button {
    padding: 0 5%;
  }
}

@media (max-width: 600px) {
  .select-manager-title {
    margin: 0 auto;
    padding: 0 0 0px 0;
  }

  .select-manager-title h3 {
    font-size: 17px;
    top: -12px;
    left: 0;
  }
  .rate-card {
    text-align: left !important;
    height: auto !important;
    width: auto;
    margin: 15px 0px;
  }

  .rate-card .convert-rate {
    position: relative !important;
    left: 0;
    right: 0 !important;
    margin: 0 !important;
  }
  .rate-card .rate-info {
    line-height: 30px !important;
    position: relative !important;
  }

  .order-container {
    width: 19%;
  }
  .rate-card {
    height: auto;
    width: auto !important;
    float: unset;
    display: block;
    text-align: center;
  }
  .container-heading-row-mobile {
    display: flex;
    flex-wrap: wrap;
    height: auto;
    margin: 0;
    border-bottom: 1px solid #e5e5e5;
    border-top: 1px solid #e5e5e5;
  }
  .checkbox-section-mobile {
    flex: 0 0 20%;
    max-width: 20%;
    padding: 18px 7%;
  }
  .select-manager-title h3 {
    position: relative;
    top: unset;
    left: unset;
  }
  .container-heading-row-mobile .title-section span {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    color: #7d8c9b;
  }

  .container-body-row-mobile {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    height: auto;
    border-bottom: 1px solid rgba(229, 229, 229, 0.4);
    padding: 0px 0px;
  }

  .title-section-mobile {
    position: relative;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #45505b;
    flex: 0 0 40%;
    max-width: 40%;
    padding: 10px 22px;
  }

  .id-section-mobile {
    position: relative;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    color: #687888;
  }

  .id-section-mobile strong,
  .role-section-mobile strong {
    color: #45505b;
    font-weight: normal;
  }
  .title-section {
    flex: 0 0 60%;
    max-width: 60%;
    padding: 15px 22px;
  }
  .role-section-mobile {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    flex: 0 0 40%;
    max-width: 40%;
    color: #687888;
    padding: 10px 22px;
  }

  .container-body-row-mobile {
    background-color: #ffffff;
  }

  .container-body-row-mobile:last-child {
    border-radius: 0 0 5px 5px;
  }

  .container-section {
    width: 100%;
    margin: 0;
  }
  .select-employee,
  .select-employee:focus {
    float: center;
    margin: 0 auto;
    width: 100%;
    background-position: 22px 14px;
    height: 48px;
  }

  .mobile-margin {
    margin: 0 3.5%;
    line-height: 10px;
  }
  .rate-card {
    width: auto;
    float: unset !important;
    display: block !important;
  }
  .tab-title {
    font-size: 14px;
  }

  .container-tabs {
    padding: 12px 0 0 0;
  }
  .mobileGrid {
    padding: 0;
    padding-bottom: 10px;
    border: none;
  }
  .container-section {
    padding: 24px 0px;
    width: 100%;
    height: auto;
    min-height: auto;
    max-height: unset !important;
    border: none;
  }
  .title-container {
    font-style: normal;
    font-weight: bold;
    font-size: 32px;
    line-height: 32px;
    vertical-align: bottom;
    text-align: center;
    letter-spacing: -0.1px;
    color: #333;
  }
  .next-btn-container {
    position: fixed;
    width: 100%;
    bottom: 0;
    margin: auto;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    height: 64px;
    padding-top: 0;
  }

  .back-button {
    width: auto;
    margin: 7px 5px;
    border-radius: 0;
  }
  .next-button {
    height: 48px;
    padding: 12px 18px;
    margin: 7px 7px;
  }
  .group-detail {
    margin: 0 0 0 20px;
  }
  .order-title {
    margin-top: 30px;
  }
  .active-border {
    border-bottom: 2px solid var(--primary-bg);
  }

  .inactive-border {
    border-bottom: 2px solid rgba(229, 229, 229, 0.4);
  }
}

// mobile Media queries
@media (max-width: 320px) {
  .manager-container-body {
    height: 49vh;
    max-height: 49vh;

  }
}

@media (max-width: 360px) and (min-width: 321px) {
  .manager-container-body {
    height: 58vh;
    max-height: 58vh;

  }
}

@media (max-width: 411px) and (min-width: 361px) {
  .manager-container-body {
    height: 63vh;
    max-height: 63vh;

  }
}
@media (min-width: 370px) and (max-width: 375px) {
  .manager-container-body {
    height: 59vh;
    max-height: 59vh;

  }
}
@media (max-width: 540px) and (min-width: 500px) {
  .manager-container-body {
    height: 62vh;
    max-height: 62vh;

  }
}
@media (max-height: 736px) and (min-height: 731px) {
 .manager-container-body {
    height: 63vh;
    max-height: 63vh;

  }
}
@media (min-height: 800px) and (max-height: 823px) {
  .manager-container-body {
    height:67vh ;
    max-height: 67vh;

  }
}
.btn:active,
.btn:focus,
.btn.active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
